import { render, staticRenderFns } from "./RpcTemplate.vue?vue&type=template&id=56534022"
import script from "./RpcTemplate.vue?vue&type=script&lang=js"
export * from "./RpcTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports